import { Action } from 'redux';
import { Event } from 'client/types/event';
import { List } from 'client/types/common';

export const FETCH_EVENTS_REQUEST = '@@homepage/FETCH_EVENTS_REQUEST';
export const FETCH_EVENTS_SUCCESS = '@@homepage/FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_ERROR = '@@homepage/FETCH_EVENTS_ERROR';

export interface FetchEventsRequest extends Action {
    type: typeof FETCH_EVENTS_REQUEST,
    payload?: number
}

export interface FetchEventsSuccess extends Action {
    type: typeof FETCH_EVENTS_SUCCESS
    payload: List<Event>
}

export interface FetchEventsError extends Action {
    type: typeof FETCH_EVENTS_ERROR
    payload: Error
}

export type EventsActionTypes =
    | FetchEventsRequest
    | FetchEventsSuccess
    | FetchEventsError;
